<section class="l-reset">
  <div class="reset">
    <a routerLink="/auth" class="reset-backLink login-header-backLink">
      {{ "Go back" | translate }}

      <img src="/assets/images/login/header-back-btn.png" alt="" class="icon" />
    </a>

    <div class="reset-body">
      <div class="reset-cover">
        <img src="/assets/images/login/reset-bg.png" alt="" class="image" />
      </div>
      <h2 class="reset-title">
        {{ "Activate Account" | translate }}
      </h2>

      <div class="form-group">
        <app-evento-input
          [eventoFormControl]="mobileField"
          type="mobile"
          requiredMessage="{{ 'Required Field' | translate }}"
          patternMessage="{{ 'Valid Email Address' | translate }}"
          placeholder="{{ 'Email' | translate }}"
        >
        </app-evento-input>
      </div>
      <button
        type="button"
        (click)="sendOtp()"
        [disabled]="mobileField.invalid"
        class="btn btn-primary w-100 mb-3"
      >
        {{ "Send" | translate }}
      </button>
    </div>
  </div>
</section>
